export default "__VITE_ASSET__DVATX5Nw__"